module.exports = __webpack_public_path__ + "img/qiye.0ccc44df.png";